export class LocalUser {
    constructor(
        public readonly uuid: string,
        public email: string | null = null,
        public matrixUserId: string | null = null,
        public isMatrixRegistered: boolean = false
    ) {}
}

// SmartScholars: Interface to match the backend DTO
export interface UtenteDTO {
    id: number;
    nome: string;
    cognome: string;
    role: 'tutor' | 'student' | 'buddy' | 'admin' | 'developer' | 'unknown';
}

// SmartScholars: Get emoji based on user role
export async function getEmojiBasedOnRole(): Promise<string> {
    // Get user ID from localStorage
    const localUserStr = localStorage.getItem('localUser');
    if (!localUserStr) {
        throw new Error('User information not found in localStorage');
    }
    const localUser = JSON.parse(localUserStr);

    // Fetch user role from backend
    const response = await fetch(`https://webapp.virtual.smartscholars.it/user/${localUser.uuid}`);
    if (!response.ok) {
        throw new Error('Failed to fetch user information');
    }
    const userData: UtenteDTO = await response.json();

    // Add emoji based on role
    console.log("Detected Role: " + userData.role);
    switch (userData.role) {
        case 'tutor':
            return '🎓';
        case 'buddy':
            return '🤝';
        case 'developer':
            return '⚙️';
        case 'admin':
            return '🛂';
        default:
            return '';
    }
}
